import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { withRouter } from 'react-router';
import Slider from "react-slick";
import classNames from 'classnames';

import classes from './HeaderToolbar.scss';
import Card from 'cityads-v3/components/Card/Card'
import Table from 'cityads-v3/components/Table/Table';
import NumberFormat, { FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat';
import ClickAwayPopper from 'cityads-v3/components/ClickAwayPopper/ClickAwayPopper';

import { loadEventInfo } from 'cityads-v3/actions/header';

@withRouter
@connect(
  state => {
    const events = state.header.bar.filter(item => item.type === 'event')[0];
    return {
      language: state.language.language,
      isLoadingLayoutData: state.menu.isLoading,
      user: state.auth.user,
      events,
    }
  }
)
@withTranslation(['main'], { i18n, wait: false })
export default class HeaderEvents extends Component {

  static propTypes = {
    user: PropTypes.object,
    events: PropTypes.object,
    isLoadingLayoutData: PropTypes.bool,
  }

  state = {
    open: false,
    currentId: undefined
  }

  anchorEl = createRef()

  componentDidMount() {
    this.loadEventsInfo();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.isLoadingLayoutData && !newProps.isLoadingLayoutData) {
      this.loadEventsInfo(newProps);
    }
  }

  componentWillUnmount() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  closeTimeout = null

  handleRequestClose = () => {
    this.closeTimeout = setTimeout(() => {
      this.setState({
        open: false,
      });
    });
  }

  loadEventsInfo(props = this.props) {
    const { events } = props;
    if(events) {
      events.data.events.forEach((event, id) => this.loadEventInfo(event, id));
    }
  }

  loadEventInfo(event, id) {
    const { url, user_key, user_id } = event;
    const apiUrl = url ? `${url}/api.php?key=${user_key}&lang=${this.props.language}&user_id=${user_id}` : null;

    if (apiUrl) {
      this.props.dispatch(loadEventInfo({
        url: apiUrl,
        id
      }));
    }
  }

  showMore(item, id) {
    this.setState({
      open: true,
      currentId: id,
      currentItem: item
    });
  }

  render() {
    const { user, events } = this.props;
    const data = events?.data;

    if (!user || !data || !data.events || !data.events.length) {
      return null;
    }

    const sliderSettings =  {
      className: classes.eventsSlider,
      dots: false,
      infinite: true,
      autoplay: events && events.data.events && events.data.events.length > 1 && !this.state.open,
      speed: 1000,
      autoplaySpeed: 5000,
      draggable: false,
      cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    };

    return (
      <>
        <div
          ref       = {this.anchorEl}
          className = {classNames(classes.item, classes.dropdownItem, classes.eventsItem, {
            [classes.dropdownItemOpen]: this.state.open
          })}
        >
          <Slider {...sliderSettings}>
            {events.data.events.map((item, num) => (
              <div
                style   = {{width: 200}}
                key     = {num}
                onClick = {() => this.showMore(item, num)}
              >
                <img src={item.img.src} alt="" />
              </div>
            ))}
          </Slider>
        </div>
        <ClickAwayPopper
          className = {classes.eventsPopover}
          open      = {this.state.open}
          anchorEl  = {this.anchorEl.current}
          placement = {'bottom-end'}
          onClose   = {this.handleRequestClose}
        >
          <EventMore id={this.state.currentId} item={this.state.currentItem} labels={events.data.labels}/>
        </ClickAwayPopper>
      </>
    );
  }
}

@connect(
  (state, props) => ({
    info: state.header.events.eventById[props.id]
  })
)
export class EventMore extends Component {

  static propTypes = {
    info: PropTypes.object,
    item: PropTypes.object,
    labels: PropTypes.object,
  }

  renderPoints({ points, total, total_currency }) {
    if (total || total_currency) {
      return (
        <NumberFormat
          number={total || 0}
          format={FORMAT_CURRENCY}
          currency={total_currency}
        />
      );
    } else {
      return points || '—';
    }
  }

  renderPosition({ position, prize }) {
    if (prize) {
      return (
        <span className={classes.userPrize} dangerouslySetInnerHTML={{ __html: prize }}></span>
      );
    }

    if (position) {
      return position;
    }

    return '—';
  }

  render() {
    const { labels, item, info } = this.props;
    const infoArray = Object.values(info || {});
    const firstRow = infoArray[0];

    const cols = [{
      name: 'name',
      title: labels.current_results
    }, {
      name: 'points',
      title: (firstRow && (firstRow.total || firstRow.total_currency)) ? labels.turnover : labels.score
    }, {
      name: 'position',
      title: (firstRow && typeof firstRow.prize !== 'undefined') ? labels.prize : labels.position
    }];

    const rows = infoArray.map(item => ({
      ...item,
      points: this.renderPoints(item),
      position: this.renderPosition(item),
    }));

    const actions = [{
      title: 'Подробнее',
      isPrimary: true,
      href: item.url
    }];

    return (
      <Card
        actions={actions}
      >
        {info ?
          (
            <Table
              cols={cols}
              rows={rows}
            />
          ) :
          null
        }
      </Card>
    );
  }
}
